<!--Report component template, styling and functionality methods.

  Industry 4.0 Report page.

-->
<template>
  
  <div>
    <div class="loadingDiv" v-if="!loaded">
      <br /><br /><br /><br /><br /><br />
      <div class="loader" style="margin: auto"></div>
      <br /><br /><br /><br /><br /><br />
    </div>

    

    <div v-if="loaded" id="reportDiv" class="animate-bottom">
      <!-- Go to www.addthis.com/dashboard to customize your tools -->
      <script type="text/javascript" src="//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-6160157660ca7555"></script>
      <div class="row">
          <div class="card-body" style="text-align: center;  color: rgb(0 155 219);">
            <h1>Industry 4.0 Readiness Assessment</h1>
          </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-md-6">
            <p style="color:rgb(0 155 219); font-weight: bold; margin-bottom:0.5px; text-align:center;">Report prepared for {{this.cn}} on {{this.date}}.</p>
            <p>The Industry 4.0 readiness assessment tool makes use of the Continuous Improvement Process (Plan, Do, Check, Act), which is a systematic approach to plan, sequence and implement improvement efforts using data. Furthermore, the Industry 4.0 Readiness Assessment tool derives its quality management principles from the IS0 9000/9001 standards.</p>
        </div>
      </div>



      <!-- MATURITY LEVELS -->

      <div id="show-levels" style="background-color: #e9e8e9; width: 100%">
        <h2 style=" color: rgb(0 155 219); text-align: center; padding: 30px">
          Your aspiration or vision
        </h2>
        <div class="container" style="padding-bottom: 15px;">
          <div class="row justify-content-md-center">
            <div class="col-md-12">
              <p>
                We've identified you currently are at level {{this.currentStateRounded}} overall. You're currently aiming for achieving a higher digital maturity level. A detailed commentary on your current state and recommended way forward can be viewed in the "Recommended next steps" section below.
              </p>
            </div>
          </div>
        </div>

        <div class="container" style="padding-bottom: 15px">
          <div class="row justify-content-md-center">
            <div class="card">
              <div class="card-body">
                <dl class="row">
                  <dt class="col-sm-3" style="text-align: center">
                    <span class="align-middle">
                      Current:
                      <p style="font-size: 25px;  color: rgb(0 155 219);">
                        {{ this.currentMatLevelIndicator }}
                      </p>
                    </span>
                  </dt>
                  <dd class="col-sm-9 text-justify" style="font-size: 18px">
                    {{ this.currentMatLevelBehavior }}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>

        <div class="container" style="padding-bottom: 15px">
          <div class="row justify-content-md-center">
            <div class="card">
              <div class="card-body">
                <dl class="row">
                  <dt class="col-sm-3" style="text-align: center">
                    Your Aim:<br />
                    <p style="font-size: 25px;  color: rgb(0 155 219);">
                      {{ this.desiredMatLevelIndicator }}
                    </p>
                  </dt>
                  <dd class="col-sm-9 text-justify" style="font-size: 18px">
                    {{ this.desiredMatLevelBehavior }}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>

        <div class="container" style="padding-bottom: 15px">
          <div class="row justify-content-md-center">
            <div class="card">
              <div class="card-body">
                <dl class="row">
                  <dt class="col-sm-3" style="text-align: center">
                    We recommend you first target:<br />
                    <p style="font-size: 25px;  color: rgb(0 155 219);">
                      {{ this.recommendedMatLevelIndicator }}
                    </p>
                  </dt>
                  <dd class="col-sm-9 text-justify" style="font-size: 18px">
                    {{ this.recommendedMatLevelBehavior }}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>

        <br />
      </div>




      <div style="width: 100%; text-align: center">
        

        <div class="container">
          <h2 style=" color: rgb(0 155 219); text-align: center; padding: 30px">
              Your Industry 4.0 Readiness / Digital Maturity Profile Report
          </h2>
          <div class="container" style="padding-bottom: 15px;">
              <div class="row justify-content-md-center">
                <div class="col-md-12">
                  <p>
                  </p>
                </div>
              </div>
            </div>
          <div class="row">
            <div class="col-lg-6">
              <div class="row">
                <div class="container">
                  <div class="card" style="border-color: white">
                    <div
                      class="card-body"
                      style="text-align: center; font-size: 20px"
                    >
                      Your Organisation is described as
                      <p style="font-size: 40px;  color: rgb(0 155 219);">
                        <strong>
                          {{ this.changeCapability }}
                        </strong>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

            <div style="padding-top: 5px; width: 100%">
                <div class="card">
                  <div
                    class="card-body"
                    style="text-align: center; font-size: 20px"
                  >
                    Your Overall Change Index:<br />
                    <strong>{{ this.changeIndex }}%</strong>
                  </div>
                </div>
              </div>

              <div class="row" style="padding-top: 10px">
                <div class="col-sm">
                  <div class="card">
                    <div
                      class="card-body"
                      style="text-align: center; font-size: 20px"
                    >
                      Your Current Digital Maturity Index:<br />
                      <strong>{{ this.currentStateAverage }}</strong>
                    </div>
                  </div>
                </div>

                <div class="col-sm">
                  <div class="card">
                    <div
                      class="card-body"
                      style="text-align: center; font-size: 20px"
                    >
                      Your Target Digital Maturity Index:<br />
                      <strong>{{ this.desiredStateAverage }}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <div id="radarchart">
                <radar-chart
                  v-if="loaded"
                  id="radargraph"
                  :chartdata="this.newData"
                  :options="this.options"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- END OF FIRST SECTION -->

        
      </div>


      <!-- NEXT STEPS-->

      <h2 style=" color: rgb(0 155 219); text-align: center; padding: 30px" >
        Recommended next steps for achieving a higher digital maturity stage / Improving Industry 4.0 readiness levels
      </h2>

      <div class="container" style="padding-bottom: 15px;">
        <div class="row justify-content-md-center">
          <div class="col-md-12">
            <p>
            'Your next steps' are suggested actions for each of the elements to reach the next level of Industry 4.0 readiness and the road to excellence. The change programme suggestions are (at this stage) based on automated responses to the answers you have given.
            </p>
          </div>
        </div>
      </div>

      <div id="nextSteppers" class="container" style="font-size: 20px">
        <!-- Vertical Steppers -->
        <div class="row mt-1">
          <div class="col-md-12">
            <!-- Stepers Wrapper -->
            <ul class="stepper stepper-vertical">
              <li class="active">
                <!--Section Title -->
                <div>
                  <span class="circle">&#10003;</span>
                  <span class="label">Organisation, Strategy and Implementation</span>
                </div>
                <!-- Section Description -->
                <div id="step1" class="step-content grey lighten-3">
                  {{ this.nextStepP1 }}
                </div>
              </li>

              <li class="active">
                <!--Section Title -->
                <div>
                  <span class="circle">&#10003;</span>
                  <span class="label">Leadership, Engagement of People, Employee Competencies, Organisational change and Training</span>
                </div>
                <!-- Section Description -->
                <div id="step2" class="step-content grey lighten-3">
                  {{ this.nextStepP2 }}
                </div>
              </li>

              <li class="active">
                <!--Section Title -->
                <div>
                  <span class="circle">&#10003;</span>
                  <span class="label">IT and IT Infrastructure, Data, Data Centre, Communication Security and the Level of Digitalisation</span>
                </div>
                <!-- Section Description -->
                <div id="step3" class="step-content grey lighten-3">
                  {{ this.nextStepP3 }}
                </div>
              </li>

              <li class="active">
                <!--Section Title -->
                <div>
                  <span class="circle">&#10003;</span>
                  <span class="label">Supply Chain, Vertical and Horizontal Integration</span>
                </div>
                <!-- Section Description -->
                <div id="step4" class="step-content grey lighten-3" >
                </div>
              </li>
            </ul>
            <!-- /.Stepers Wrapper -->
          </div>
        </div>

        <br />
      </div>

      <hr />
      <div class="container">
        <div class="row justify-content-center" style="text-align: center">
          <div class="card col-lg-7" style="border-color: white">
            <p>
            <i>
              Your results ID is {{this.idx}}. If you wish to save your results, simply use your browser function to save the page (CTRL-P).
            </i>
            </p>
          </div>
        </div>
      </div>

      <hr id="formRowHR" />    

      <div class="container" id="formRow">
        <div class="row justify-content-center" style="text-align: center">
          <div class="card col-lg-7" style="border-color: white">
            <h2 id="enterEmailh2" style=" color: rgb(0 155 219); text-align: center; padding: 30px">To assist with our research would you please enter your email address for record of participation</h2>
            <div class="card-body" style="font-size: 20px">
              <div id="formPlacement" v-once></div>
            </div>
          </div>
        </div>
      </div>

      <!-- QUOTE -->
      <div style="background-color: #e9e8e9; width: 100%; font-size: 20px">
        <div class="container" style="padding: 30px">
          <div class="card">
            <div class="card-header">Doesn't sound quite right?</div>
            <div class="card-body">
              <blockquote class="blockquote mb-0">
                <p>
                  <i>
                    It would be perfectly natural to over inflate the assessment
                    scores; the reality of the as is situation may not be
                    palletable to most. However, a frank, honest look into the
                    process & systems mirror will yield a credible base line to
                    work from.
                  </i>
                </p>
                <footer class="blockquote-footer">
                  If you wish to contact the doctorate research team, please write to us at <a href="mailto:ahsan.jawad@addenergy.no">ahsan.jawad@addenergy.no</a>
                </footer>
              </blockquote>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>


<script>
// Import the radar visualisation from the .vue file.
import RadarChart from "./RadarChart";

// Exporting should kinda be seen as "This is how I'm gonna package up my page into a box for when it needs to be used".
// All of the events and functions required on the page are put into this bit.
export default {
  data() {
    return {
      fRow : null,
      from: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.from = from;
    });
  },

  // As soon as the page's instance is bound - Good diagram on the app lifecycle: https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram
  mounted() {
    // Check where this redirect came from. If it came from a submit email page don't attempt to load the submit email form at the bottom of the page.
    // This bit of code came from the HubSpot site. 
    if (this.from.path == "/take-the-quiz" || this.from.name != "submitEmail") {
      const script = document.createElement("script");
      let self = this;
      script.src = "https://js.hsforms.net/forms/v2.js";
      document.body.appendChild(script);
      script.addEventListener("load", () => {
        if (window.hbspt) {
          setTimeout(function() {
            window.hbspt.forms.create({
            region: "na1",
            portalId: "3825857",
            formId: "9f1f77c2-e6ca-4aba-9729-1e30917fdc17",
            target: "#formPlacement",
            onFormSubmit: function ($form, ctx) {
                document.getElementById("formRow").style.display = "none";
                document.getElementById("formRowHR").style.display = "none";
                document.getElementById("enterEmailh2").style.display = "none";
            },
            });
          }, 2000);
        }
      });
    } else {
      // If the previous page was a page where they had to submit an email, don't load the email input form & hide it's supporting elements.
      setTimeout(function() {
        document.getElementById("formRowHR").style.display = "none";
        document.getElementById("formRow").style.display = "none";
        document.getElementById("enterEmailh2").style.display = "none";
      }, 2000);
    }

    // Set the next step descriptions.
    document.getElementById("step1").innerHTML = this.nextStepP1;
    document.getElementById("step2").innerHTML = this.nextStepP2;
    document.getElementById("step3").innerHTML = this.nextStepP3;
    document.getElementById("step4").innerHTML = this.nextStepP4;

    // Create the add This script element and add it onto the page. This bit is the sidebar for sharing the report.
    let scrpt = document.createElement("script");
    scrpt.id = "addThisScript"
    scrpt.type = "text/javascript";
    scrpt.src="//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-6160157660ca7555"

    document.body.prepend(scrpt);
  },

  components: {
    RadarChart,
  },

  beforeCreate() {
    //this.HOST_URL = this.$HOST_URL;
  },

  // Before someone redirects somewhere else, scrap the sidebar.
  beforeRouteLeave (to, from , next) {
    $("#addThisScript").empty();
  },

  // As soon as the page instance is created, start parsing the params & values passed via the URL.
  created() {
    // Get the query section from the URL
    const queryString = window.location.search;
    // Parse the query section into a URLSearchParams object. This object will do most of the work for us when it comes to getting key value pairs.
    const urlParams = new URLSearchParams(queryString);

    // Get all of the data from the URL via their keys.
    this.idx = urlParams.get("idx");
    this.cn = urlParams.get("cn");
    this.part1curr = parseFloat(urlParams.get("p1c"));
    this.part1future = parseFloat(urlParams.get("p1f"));
    this.part2curr = parseFloat(urlParams.get("p2c"));
    this.part2future = parseFloat(urlParams.get("p2f"));
    this.part3curr = parseFloat(urlParams.get("p3c"));
    this.part3future = parseFloat(urlParams.get("p3f"));
    this.part4curr = parseFloat(urlParams.get("p4c"));
    this.part4future = parseFloat(urlParams.get("p4f"));

    // Get the average scores for the user's Current and Desired Industry 4.0 levels
    this.currentStateAverage = (this.part1curr + this.part2curr + this.part3curr + this.part4curr)/4;
    this.desiredStateAverage = (this.part1future + this.part2future + this.part3future + this.part4future)/4;

    // We need to round their scores to present the correct aims. 
    // We round the current to floor because they can't have 1/2 progress towards the next level. They're at x and currently working towards x+1.
    this.currentStateRounded = Math.floor(this.currentStateAverage);
    // We round the desired towards the closes number so that if they get 4.9, it will show they're wanting to head for 5, instead of 4.
    this.desiredStateRounded = Math.round(this.desiredStateAverage);

    this.currentMatLevelID = this.currentStateAverage;
    this.desiredMatLevelID = this.desiredStateAverage;

    // The idx passed from the URL is actually just a timestamp. It allows us to take the submission time and display it on the page.
    let d = new Date(parseInt(this.idx));
    this.date = d.getDate() + '/' + (d.getMonth()+1) + '/' + d.getFullYear()




    // getIndicator() is used to get the corresponding level name for a specified int representation of the level.
    function getIndicator(state){
      switch(state) {
        case 1: 
          return "Beginner";
        
        case 2: 
          return "Intermediate";
          
        case 3: 
          return "Skilled";            
          
        case 4:
          return "Expert";
          
        case 5:
          return "Influencers/Champions";
      }
    }


    // getBehaviour() takes the int respresentation of the user's Industry 4.0 level and returns the relevant description.
    function getBehaviour(state){
      switch(state) {
        case 1: 
          return "You are at a stage where you are just beginning to embark on your journey towards adopting Industry 4.0. You need to identify improvement opportunities and select the appropriate process for improvement. Your organization must acquire digital fluency and enhance Industry 4.0 literacy by engaging in relevant training programmes. Assessing current processes, identifying areas requiring action and envisioning the targeted digital maturity level will help develop a targeted and organization-specific digital transformation road map.";
              
        case 2: 
          return "At an intermediate stage, your organization should have plans for implementing Industry 4.0, and based on those plans, you may have initiated efforts to acquire a higher digital maturity level. Your organization must identify areas where the adoption of Industry 4.0 could provide the most beneficial results (resources allocated vs the return on investment). Your organization will be faced with transitional challenges that need to be identified, analysed and tackled. The organization must develop a planned approach towards mitigating the transitional challenges for ensuring a smooth transformation to Industry 4.0.";
                
        case 3: 
          return "At a skilled level, implementation of Industry 4.0 should be in perspective. You have successfully identified the right areas/functions where Industry 4.0 yields the most beneficial results and have initiated pilot implementation projects. You have learnings from the pilots that you can utilize for your future implementation endeavours. Your organization is capable of identifying root causes for the persistence of transitional challenges and implementing corrective measures. The organization requires incremental efforts to improve over time for achieving expertise and higher digital maturity.";
                
        case 4:
          return "At an expert level, your Industry 4.0 implementation efforts are planned, initiated and executed with diligence, incremental improvement is verified, and the learnings are utilized for improving transformation efforts. A successful Industry 4.0 transformation will bring tangible financial benefits by reducing operating costs and improving business efficiency and other less quantifiable benefits such as being recognized as an innovative brand and market-leading. Implementation is a major change project and cannot be concentrated on for a couple of years and then assumed to be “done”. It must become the bedrock of how the company works and how its processes are structured. Your organization will require a solid commitment to investing, not just in the technology and IT equipment, but more importantly, in process, people and culture. While digital technologies are rapidly becoming a commodity, your success will largely depend on your organisation’s digital capability and skills and its leaders’ commitment to define, lead and communicate the transformation.";
          
        case 5:
          return "At the level of champions/influencers, you are at the top level of digital maturity with Industry 4.0 implementation in perspective. Being the early adopters, your organization has managed to adopt digital far in advance than most of your competition in the industry, providing you with a competitive edge. Your digital transformation has been directed by a stringent digital transformation strategy that is aligned with your overall business strategy. Being a resilient organization, you are vigilant and thrive continuously by confirming actions taken to achieve the target. The improvement process must continue to convert the competitive edge into a sustainable digital competitive advantage over the competition.";
      }
    }

    // Using the desired Industry 4.0 level, get the indicators & behaviour description.
    this.desiredMatLevelIndicator = getIndicator(this.desiredStateRounded);
    this.dMaturityIndicator = getIndicator(this.desiredStateRounded);
    this.desiredMatLevelBehavior = getBehaviour(this.desiredStateRounded);

    // Using the current Industry 4.0 level, get the indicators & behaviour description.
    this.currentMatLevelIndicator = getIndicator(this.currentStateRounded);
    this.cMaturityIndicator = getIndicator(this.currentStateRounded);
    this.currentMatLevelBehavior = getBehaviour(this.currentStateRounded);

    // Calculate what state the user should be aiming for. If they're already at level 5, you can't go higher. Otherwise, just add 1 to the current level.
    // Get the indicator and behaviour description for the level we recommend (Current + 1)
    let recommendedState = this.currentStateRounded == 5 ? 5 : this.currentStateRounded + 1 
    this.recommendedMatLevelBehavior = getBehaviour(recommendedState);
    this.recommendedMatLevelIndicator = getIndicator(recommendedState);
    


    // We now want to get the step data for each part. It'll be for 1 level higher than their current, so we want to make sure we're not going out of the level limits (more than 5).
    let part1Step = Math.floor(this.part1curr)+1 >= 5 ? 5 : Math.floor(this.part1curr)+1;
    let part2Step = Math.floor(this.part2curr)+1 >= 5 ? 5 : Math.floor(this.part2curr)+1;
    let part3Step = Math.floor(this.part3curr)+1 >= 5 ? 5 : Math.floor(this.part3curr)+1;
    let part4Step = Math.floor(this.part4curr)+1 >= 5 ? 5 : Math.floor(this.part4curr)+1;

    // Get the next steps for each of the levels.
    this.nextStepP1 = getStep("P1", part1Step);
    this.nextStepP2 = getStep("P2", part2Step);
    this.nextStepP3 = getStep("P3", part3Step);
    this.nextStepP4 = getStep("P4", part4Step);


    // getStep() retrieves the corresponding text containing suggestions on how to level up a user's Industry 4.0 level.
    // A sector (part number) is provided to get the relevant step for the part.
    function getStep(sector, score) {
        switch (sector) {
            
            case "P1":
                switch (score) {
                case 2:
                    return "You are a beginner in your Industry 4.0 transformation journey. Industry 4.0 literacy/awareness levels need to be raised as a priority. It is important to establish your organization’s strategic objectives for the current and next few years, the areas in which it intends to add value through Industry 4.0, the extent to which it hopes to do so, and the indicators that can be used to measure the results. Based on the results, the next step can be to identify the capabilities your organization needs to acquire to implement Industry 4.0 successfully. A gap analysis can then be used to compare the current Industry 4.0 capabilities with what it requires to meet its strategic transformational objectives. The measures needed to be taken to acquire the missing capabilities can then be included in a digital transformation plan. <br/><br/><i>Training for raising digital awareness and Industry 4.0 literacy, as well as training for acquiring digital competence, will be required.</i>";
                case 3:
                    return "Your organization is at a stage where strategic planning and making correct decisions are vital to pave the way for a successful Industry 4.0 transformation. For Industry 4.0 to take hold, it must be deep-rooted into the organizational strategy. Industry 4.0 transformation cannot be achieved using only spare time; instead, its adoption demands commitment and allocation of resources to ensure that the implementation starts to yield potential benefits. The strategy drives Industry 4.0 implementation by making sense of the use of technology in the most beneficial way while ensuring that the risks associated with investing in the digital are reduced to the bare minimum. Lack of a distinct strategy or its misalignment with the overall business strategy often leads to disappointments and a one-way ticket to the trough of disillusionment. A digital strategy must be developed to consider the issues and challenges facing Industry 4.0 implementation and provide a guided road map for realising the digital transformation objectives.<br/><br/>Your organization must acquire the capabilities/expertise required for assessing current processes, identifying areas requiring actions, and developing case-specific practical guidelines for achieving the intended digital transformation goals by following a step-by-step guided Industry 4.0 transformational roadmap. Data lies at the heart of the digital transformation, but data is of significance if the quality and veracity are intact. Furthermore, available data should provide actionable insights, and those insights must be used for making informed decisions. Evidence-based decision making (EBDM) is a method that emphasizes using data and experiential evidence to make decisions. For ensuring compliance with the international standards and quality management principles (ISO 9000/9001) your organization must make EBDM an integral part of the decision-making process.  Your organization must also acquire proficiencies in assessing current levels of digitization and digital competence. These proficiencies allow future requirements to be identified and resources allocated for acquiring digital technologies and attaining higher levels of digital competence and skill required for using digital technologies. These projects will result in economic benefits that start flowing into the organization. <br/><br/><i>Your organization must acquire proficiency in planning the strategic Industry 4.0 implementation. Your organization requires training for developing a robust digital strategy that could enable it to plan rationally and identify accurately the right functional areas, where pilot implementation projects could be initiated, so that the resulting economic benefits start flowing into the organization at every stage of the implementation, over the period.  Furthermore, for ensuring compliance with the international standards and quality management principles, you might also consider training requirements for attaining a clear understanding of the relevant standards (e.g., ISO 9000/9001).  Trainings for conducting and coordinating robust digital change management initiatives can help achieve smooth transition towards adopting Industry 4.0. Having a clear digital strategy would provide the organization with a better line of sight and instil confidence in the organization for engaging in digital ventures.</i>";
                case 4:
                    return "Since Industry 4.0 transformation is a highly complex undertaking, it might usually take several years. Therefore, it should be planned and implemented in such a way as to ensure that positive impacts on profitability, growth and efficiency occur at various stages throughout the transformation.  At this stage, where the transformational efforts have been initiated for the past few years now, your organization must ensure adherence to the digital strategy developed, strict compliance to continuous process improvement and quality management principles. Learnings from pilot implementations and the results from the deployment should be garnered for improving future transformational efforts. Industry 4.0 must be entrenched in the overall organizational strategy at functional, business and corporate levels aligned with the overall business strategy. Evidence-based decision making must be of significant importance to the organization as utilising insights from quality data would allow key indicators to be determined, measured and monitored to demonstrate the organization’s performance. <br/><br/><i>For acquiring higher digital maturity your organization must be able to plan and execute the strategic Industry 4.0 implementation. Training will be required for enabling organizations determine short and long-term achievable goals, adoption of courses of action and allocation of resources for achieving the digital transformation goals.  Digital capability, competence and capacity building trainings should be undertaken that could help organizations use Industry 4.0 technologies to pursue growth and operational excellence across multiple verticals.</i>";
                case 5:
                    return "For Industry 4.0 to be sustainable, it must be embedded into the business strategy and founded on a strong digital culture and skills base. To move towards becoming digitally mature, the organization must enhance visibility to provide deeper insights into operations and processes. This visibility helps the organization develop a competitive strategy to capitalise on the potential benefits of IOT, smart connectivity and advanced analytical capabilities by enabling Industry 4.0. Agility denotes the ability of an organization to implement changes in the company in real-time, including fundamental systematic changes to the company's business model and operations. Industry 4.0 must be deep-rooted in the overall organizational strategy at functional, business, corporate and network levels for ensuring a smooth transition towards Industry 4.0. Results from implementation must be utilized as indicators of success for future planning and implementation for ensuring a smooth digital transition. For achieving a higher digital maturity status, evidence-based decision making must form the core and a systematic technology, innovation, and change management (STICM) mechanism must be active now. A resilient mechanism for identifying pain points and prioritising relief measures continuously must be actively functional to help the organization remain resilient, unlock efficiencies, optimise processes, reduce costs, and mitigate risks. Structured training programmes to enhance the digital skills set for existing and new staff will prove beneficial, giving rise to an innovative and digital culture. <br/><br/><i>It is the strategy that drives Industry 4.0 implementation. Your organization must acquire mastery in developing a resilient digital strategy and executing implementation plans. Compliance to quality management principles and other standards is of crucial importance. Training needs for capacity building and ensuring compliance can expedite the adoption process. The staff must acquire trainings for attaining enhanced data analytical capabilities for achieving a mature digital level.</i>";
            }
            
            case "P2": 
                switch (score) {
                case 2:
                    return "At this stage as beginner/ new adopters, the leadership recognises the benefits of Industry 4.0, but it is often a long way from turning it into a way of life. Therefore, the leadership is required to establish unity of purpose and provide direction for aligning strategies, policies, and processes for achieving the Industry 4.0 transformation goals. However, for attaining higher digital maturity, the leadership needs to evaluate the transitional and transformational challenges facing the adoption and implementation of Industry 4.0. Digital savvy leadership will instil confidence and trust in the team and allow strategies to be developed to overcome the challenges and for realising the true potential of digitalisation. <br/><br/>The digitalisation of different industries has dramatically transformed the skill sets required by employees. For the benefits of Industry 4.0 to be realised, the workforce must use the digital technology at their disposal. Digitalisation is of no value if the personnel lack the skills to make use of it.  At early stages, competence, empowerment, and people’s engagement at all levels throughout the organization doesn't exist. Assessments must be carried out to identify specific training requirements required for enabling the employees to adapt to the ever-evolving digital environment. Programme specific capacity building training can benefit organizations leap of faith towards Industry 4.0 transformation. Recognizing peoples' contributions, facilitating open discussions, knowledge sharing, empowering people to determine constraints to performance and encouraging self-initiative without fear can help foster a digital culture. <br/><br/><i>Leadership skills and capacity development trainings will be required to equip the leadership with the most relevant and modern digital mega trends for augmenting their Industry 4.0 vision. The digitalisation of different industries has dramatically transformed the skill sets required by employees. Trainings will be required for enhancing employees’ competence and capabilities. Change management trainings focused on making innovation a part of the organizational culture may help foster digital culture and improve overall organizational resilience.</i>";
                case 3:
                    return "To be successful, the industry leaders must drive cultural change. At this stage, leadership must diligently plan how competence, empowerment, and engagement of people can be ensured in the right way to realise the digital transformation objectives. The increasing frequency of changes triggered by Industry 4.0 interventions in different industries means that decisions about how to respond must be taken swiftly by the leadership without impairing their quality.  Appropriate measures need to be taken and implemented to ensure a turbulence-free transformation by adopting a more flexible approach to value them as part of the community because of the competencies that they bring to the table. <br/><br/><i>At this stage it is observed that organizations engage in training current employees, which reflects the difficulty organizations have had in recruiting people with appropriate digital skill set, whether from universities or the industry. Organizations must make efforts towards acquiring the digital skills that are lacking amongst the current employees through specialised training, seminars, knowledge transfer systems, coaching etc., as well as acquire expertise in hiring the right talent with the right skill set. Leadership digital literacy and skills enhancement trainings can help the digitalisation vision cascade down the whole organization in a very smooth way and provide unity of purpose to the organization. Change management trainings focused on co-creating solutions and managing the transformation as one resilient unit may help Industry 4.0 implementation significantly.</i>";
                case 4:
                    return "At this stage, the plans rationally developed by the leadership start to pay off in establishing unity of purpose and aligning processes and resources for achieving higher digital maturity by enhancing employees’ competence, empowerment and engagement. The democratic leadership style values people for their contribution, which gives rise to a culture of open communication. Moreover, the workforce is both receptive and willing to change. They learn systematically from their prior experiences, are open to innovative approaches, and shape change processes. <br/><br/> To achieve a higher digital maturity status, the organisation must make sure that the employees are continuously conscious of developing their skills and competencies. While mistakes might still occur, people will recognise that they are valuable because they can trigger improvements. <br/><br/><i>The leadership and the employees should be conscious of the need that continuous development is of pivotal significance for improving organizational competence and capabilities. Training needs for augmenting and boosting the existing skills and competence levels of the employees and their engagement at all required levels will be required. Digital solution will provide organizations with a competitive edge over the competition, however it is the digital capability, competence and intellect that enables organizational transformation. Digital transformation master trainings, tailor made for specific organisations may prove very helpful in enabling organisations make their transformation a success.</i>";
                case 5:
                    return "Leadership teams must understand the potential benefits to be realised and are developing plans to invest more rationally. However, implementing Industry 4.0 will require far more than the senior leadership team paying lip service by purchasing new technology. It also requires cross-functional support by adopting relevant measurements and collaborative working methods at both strategic and operational levels. <br/><br/>Achieving a higher digital maturity level will require a strong commitment from the leadership to invest, not just in the technology and IT equipment, but more importantly, in process, people and culture. Leadership must drive and become a part of the cultural change. The organization must ensure that the right capabilities and equipment are invested in and sustained through constant training, process monitoring and technological enhancement. Continuous improvement will be the key. <br/><br/><i>Resilient and Agile organizations are those that are capable of responding to disruptive changes, respond and thrive during challenging times. For remaining resilient, capacity building trainings will be required for ensuring continuous improvement.  Departments will need to be open to cross-company collaboration to drive improvements.</i>";
            }

            case "P3": 
                switch (score) {
                case 2:
                    return "As a beginner, your organization should identify the IT and OT requirements specific to your organizational needs with Industry 4.0 adoption in perspective. Digitisation is one of the prerequisites to digitalisation (i.e., Industry 4.0). The IT and information security management system (ISMS) needs to be organized to operate risk-free in the cyber world (ISO/IEC 27000). It is vital to decide very carefully whether to opt for a centralised or decentralised IT department. Outsourcing might also be one option, but the risk of being vulnerable in the volatile cyber world lies with outsourcing. You should also consider using cloud services for several purposes like data collection and storage to eliminate the dependencies and limitations of conventional data collection and storage means.  These changes will be a major step towards achieving digitalisation. Using digital technologies (e.g., NFC, RFID, data mining, etc) and developing competencies around digital technologies for data extraction, collection, enrichment, and analysis may significantly improve the data quality and veracity. <br/><br/>Improving the level of digitalisation and the use of digital technologies is only worth it if it impacts the revenue stream positively. Therefore, due diligence must be exercised when assessing the current needs for digitalisation, and those needs must be cross evaluated against the potential benefits of implementation. Contribution to the revenue stream derived from data-driven services is a key indicator for measuring the success of any digitalisation effort. <br/><br/><i>Trainings and courses aimed at improving the organizations' capabilities in being able to identify the IT/OT requirements suitably as well as enhancing their understanding of developing an 'As a service business model' can help organizations develop the right skill set for achieving their Industry 4.0 transformation goals. Information technology security represents a new high-risk area, that touches virtually every major aspect of an organization's operation that is intending to transform into a digitally mature organization. Training for capacity building, raising awareness and understanding of information security risk among organizational employees as well as senior officials is a necessity for achieving higher digital maturity.</i>";
                case 3:
                    return "At this stage, your organization should strive towards bringing together different information technologies used in isolation within the organization via integration, ensuring visibility of operations and transparency. The scope must be identified for the IT and Information Security Management System (ISMS). When it comes to keeping information assets secure, organizations can rely on the ISO/IEC 27000 family. ISO/IEC 27001 is widely known, providing an information security management system (ISMS) requirements.  Digital technologies (e.g., character and image recognition) should be used for data extraction for improving data quality. Cloud services should be used for collection, storage and data residency to eliminate the dependencies and limitations of primitive ways of data enrichment. <br/><br/>IT training security matrix for organizations at this stage should explore training areas related to laws and regulations (e.g. Federal IT security law, regulations, legal and liability issues), security programme, life cycle security, system interconnection and information sharing, risk management and IT security basics and literacy, etc. IT security must not be confused with the term computer literacy, which refers to an individual's familiarity with a basic set of knowledge needed to use a computer. IT security literacy refers to an individual's familiarity with and ability to apply the core knowledge set required to protect electronic information and systems. <br/><br/>Organizations will be required to develop new, combined solutions from a range of components from suppliers of sensors, modules, control systems, communications networks, business applications, and customer-facing applications. <br/><br/><i>Trainings will be required for improving organizational capabilities in being able to identify IT/OT requirements and make use of digital technologies. Organizations will have to keep information assets secure, and for that they may rely on acquiring proficiency in related international standards, for e.g., ISO/IEC 27000 family. ISO/IEC 27001 is widely known, providing requirements for an information security management system (ISMS). Trainings aimed at enhancing IT security literacy may significantly improve an organization’s information security. The organization may wish to explore areas related to training in terms of laws and regulations (e.g., Federal IT security law, regulations, legal and liability issues), security programme, life cycle security, system interconnection and information sharing, risk management and IT security basics and literacy, etc. </i>";
                case 4:
                    return "Although many of the terms sound the same or similar, the requirements that production and data centre applications require in terms of IT differ considerably. Organizations must acquire capabilities for understanding and distinguishing between the two very clearly. The production perspective gives rise to a range of IT infrastructure requirements, like industrial interface and protocols, real-time data processing, safeguarding against failure, design redundancy up to machine level etc.,<br/><br/>Data centre infrastructure includes all of the physical components in a data centre environment. These may consist of storage systems, servers, network infrastructure, switches and routers, and various information security elements, such as firewalls etc. The extensive networking and high levels of data sharing involved with Industry 4.0 in perspective will significantly increase the demands made on data security. Like many other organizations pursuing attaining higher digital maturity, your organization will urgently need a tailored risk management system and a security strategy geared to cyber security to improve operational security, protecting from attacks right across the value chain. These improvements will help organizations protect the new products, data, intellectual property, etc., against unauthorised use and/or abuse. <br/><br/>The organization must invest in and develop digital capabilities for improving data quality from the very beginning i.e., data extraction, collection and enrichment stage. Insights from quality data available can then be used for achieving operational excellence, optimization of resource consumption, quality management, enhancing visibility and transparency of operations. Similarly, cyber security is one of the most significant issues in operating in the digital world. The organization must acquire the right skill set when it comes to ensuring cyber security. Moreover, for gaining higher digital maturity levels and for improving continuously, the organization should develop their competency in understanding and managing data centre development, data centre reliability, data centre equipment (the equipment in a data centre: IT, power, cooling, and layouts etc.,). When it comes to keeping information assets secure, organizations can rely on the ISO/IEC 27000 family. ISO/IEC 27001 is widely known, providing an information security management system (ISMS) requirements. <br/><br/><i>The extensive networking and high levels of data sharing involved with Industry 4.0 in perspective, will greatly increase the demands made on data security. Organizations will have to keep information assets secure, and for that they may rely on acquiring proficiency in related international standards, for e.g., ISO/IEC 27000 family. ISO/IEC 27001 is widely known, providing requirements for an information security management system (ISMS).  Trainings related to laws and regulations covering data security may also need to be explored. Training programmes targeted specifically at improving the IT/OT, information security, data exchange mechanism and enhancing analytical capabilities will be required for achieving higher digital maturity levels.</i>";
                case 5:
                    return "The adoption of new technologies leads to competitive advantages. At this stage, organizations must remain resilient and push hard towards ensuring continuous improvement. The future of the data centres will rely heavily on artificial intelligence (AI) and machine learning (ML) to improve business processes. Cloud architectures will have to be improved to match the desired outcomes or to fulfil the purpose intended. Enhanced data analytical capabilities must be attained to remain relevant in the age of Industry 4.0. <br/><br/>Business should develop a vigilant and robust IT department (centralised or decentralised depending on what suits the best). IT and Information Security Management System (ISMS) should be fully operational at all required levels, and re-assessment audits conducted that evaluate the overall outcome of the corrective actions. A new round of the cycle should be initiated with corrective input, where necessary. Veracity and quality of data available or being generated must be ensured, and the insights from such data should be utilised optimally. The IT and OT requirements must be visited and revisited to ensure that relevant technology and skills required are developed continuously. <br/><br/><i>Organization must acquire trainings for developing knowledge and competence base with focus on artificial intelligence (AI) for enabling the data centres of future. For remaining relevant in the age of Industry 4.0, organizations must remain resilient and improve continuously.</i>";
            }

            case "P4": 
                switch (score) {
                case 2:
                    return "As a beginner in your transformational journey, one of the most significant issues faced will be integrating your supply chain. There are three vital features fundamental to assessing the digital maturity and adoption of Industry 4.0, namely, (i) horizontal integration via value chains, (ii) vertical integration and networking of manufacturing or services systems, and (iii) end-to-end integration of value chain.  One of the biggest challenges facing Industry 4.0 implementation is not how companies apply individual technologies or make improvements in single business functions but how effective they are at developing an integrated supply chain approach that connects with suppliers and customers. This is the only way to exploit the potential that Industry 4.0 offers fully. <br/><br/>At this stage, your organization must eliminate ad-hocism, do away with reactive communications with suppliers and move towards improving basic communication and data sharing more rationally. Real-time data management for procurement and inventory control may improve asset performance management.  Supply chain visibility and flexibility must also be improved to increase digital maturity and ensure digitization across functions. Ensuring integrated cross-departmental information sharing into your organizational systems/functions is pivotal for enhancing digital maturity. Your organization must develop competencies in supply chain 4.0 practices. <br/><br/><i>Your organization must plan towards engaging in training programmes for acquiring supply chain 4.0 competencies i.e., trainings enabling organizations achieve supply chain integration. More successful organisations have started by identifying the challenges that exist within the organisation, with the awareness of what is going on elsewhere in the industry providing a steer rather than inspiration. </i>";
                case 3:
                    return "Achieving full digital collaboration and then using it effectively throughout the supply chain requires all companies to develop processes, capabilities and systems to support them. Your organization must now move a step forward in collaborative ventures. <br/><br/>Industry 4.0 should not only involve the digitalisation of horizontal and vertical value chains but will also revolutionise the product and service portfolio of companies, with the goal of better satisfying customer needs in a cost-effective method. To ensure that customers will benefit from better services and flexibility, your organization will need to be capable of immediately responding to changes in the market environment (Supply chain flexibility) and individual customer requirements. Better supply chain agility could mean shorter lead time and more flexibility in your organisation’s service to its customers. Furthermore, higher digital maturity would allow for better visibility of upcoming demand and inventories throughout the supply chain (Supply chain visibility). Real-time information about site location, capacity, inventory, and operations throughout the supply chain enables better response to customers’ needs. This information sharing allows supply chain integration, facilitating a more agile response from upstream suppliers to downstream logistics providers, driving efficiencies and improved service throughout the supply chain. <br/><br/><i>Training will be required to plan and achieve digital collaboration by developing processes, capabilities, and systems to support each other and enhance supply chain visibility.</i>";
                case 4:
                    return "Your organization must now embed the concept of supply chain integration into the hearts and minds of all those up and down the supply chain, moving beyond ad-hoc approaches and distrust. This will require an aligned understanding of the capability levels, business process gaps, and systems both internally and across suppliers and customers. Adopting a culture in all relationship elements to promote an effective collaborative approach will also be required. <br/><br/>Your organization must acquire capabilities for developing an integrated supply chain approach, allowing intelligent information sharing and communication with suppliers and customers to drive agility and efficiency. Your organization must also become proficient in identifying and gathering real-time information using advanced technologies, deploying it for the right purposes and effectively analysing it to make the right decisions timely and accurately. <br/><br/><i>Training requirements for developing an integrated supply chain approach will be required. Training will be required to plan and achieve digital collaboration by developing processes, capabilities, and systems to support each other and enhance supply chain visibility.</i>";
                case 5:
                    return "Organisations attempting to transform on their own will suffer from slow progress and wasted effort. At this stage, a collaborative approach will be required to demonstrate to all participants that the benefits of integration will be shared, and the knowledge gained will not be used adversely against the weaker players in the supply chain. Maintaining a high degree of supply chain integration, visibility, and flexibility using digital technologies will be key success factors enabling the organization to realise the benefits of adopting Industry 4.0. <br/><br/>Your organization must also thrive towards achieving complete digitalisation, ideally at all integrated levels (horizontal and vertical). Horizontal integration of a company’s processes means optimising the interrelation between all process stages within the value chain. IT and IT infrastructures play a crucial role here, as they enable communication between the individual stages and provide a targeted means of managing them. Essential for the success of horizontal integration is the application of customer requirements to a specific product. On the other hand, vertical integration is when a business expands by acquiring another company that operates before or after them in the supply chain. <br/><br/>In the wake of digitization, logistics processes will have to become smarter across new generations of global value chain networks. This applies to inbound logistics, intra-logistics, and outbound logistics. <br/><br/>The digital transformation will create a single database, making supply chains smarter, more transparent, more responsive, and more efficient at every stage, from customer needs to delivery. <br/><br/><i>For remaining resilient your organization must also become proficient through master training programmes in being able to identify and gather real-time information using advanced technologies, deploying it for the right purposes and effectively analysing it to make the right decisions timely and accurately. Training requirements for developing an integrated supply chain approach will be required. </i>";
            }
                
        }	
    }

    // Get the change index % to display on the page
    this.changeIndex = Math.round((this.currentStateAverage*100)/5);
    this.currentStateAverage = Math.round(this.currentStateAverage * 100) / 100
    this.desiredStateAverage = Math.round(this.desiredStateAverage * 100) / 100
    
    // Use the changeIndex to get the relevant text for change capability
    if(this.changeIndex < 40) {
        this.changeCapability = "Beginner";
        this.changeCapabilityDescription = " ";
    }
    else if(this.changeIndex >= 40 && this.changeIndex < 60) {
        this.changeCapability = "Intermediate";
        this.changeCapabilityDescription = " ";
    }
    else if(this.changeIndex >= 60  && this.changeIndex < 80) {
        this.changeCapability = "Skilled";
        this.changeCapabilityDescription = " ";
    }
    else if(this.changeIndex >= 80  && this.changeIndex < 100) {
        this.changeCapability = "Expert";
        this.changeCapabilityDescription = " ";
    }
    else if(this.changeIndex == 100){
        this.changeCapability = "Influencers/Champions";
        this.changeCapabilityDescription = " ";		
    }




    let part1cInt = Math.floor(this.part1curr);
    let part1fInt = Math.floor(this.part1future);
    let part2cInt = Math.floor(this.part2curr);
    let part2fInt = Math.floor(this.part2future);
    let part3cInt = Math.floor(this.part3curr);
    let part3fInt = Math.floor(this.part3future);
    let part4cInt = Math.floor(this.part4curr);
    let part4fInt = Math.floor(this.part4future);

    // Package the generated data into a dictionary used by vue. This is also used to generate the charts.
    this.newData = {
    labels: [
        "Strategy & Implementation",
        "Organisational Competence",
        "IT Infrastructure & Digitalisation",
        "V/H Integration",
    ],
    datasets: [
        {
        label: "Where you are",
        backgroundColor: "rgba(255, 99, 132, 0.2)",
        borderColor: "rgb(255, 0, 132)",
        pointBackgroundColor: "rgb(255, 99, 0)",
        data: [
            this.part1curr,
            this.part2curr,
            this.part3curr,
            this.part4curr,
        ],
        },
        {
        label: "Where you want to be",
        backgroundColor: "rgba(54, 162, 235, 0.2)",
        borderColor: "rgb(54, 0, 235)",
        pointBackgroundColor: "rgb(54, 162, 0)",
        data: [
            this.part1future,
            this.part2future,
            this.part3future,
            this.part4future,
        ],
        },
    ],
    options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
        position: "top",
        },
        title: {
        display: true,
        text: "",
        },
        scale: {
        ticks: {
            beginAtZero: true,
            max: 5,
            min: 0,
            stepSize: 1,
        },
        },
        tooltips: {
        enabled: false,
        callbacks: {
            label: function (tooltipItem, data) {
            var datasetLabel =
                data.datasets[tooltipItem.datasetIndex].label || "";
            //This will be the tooltip.body
            return (
                datasetLabel +
                ": " +
                tooltipItem.yLabel +
                ": " +
                data.datasets[tooltipItem.datasetIndex].notes[
                tooltipItem.index
                ]
            );
            },
        },
        custom: function (tooltip) {
            // Tooltip Element
            var tooltipEl = document.getElementById("chartjs-tooltip");
            if (!tooltipEl) {
            tooltipEl = document.createElement("div");
            tooltipEl.id = "chartjs-tooltip";
            tooltipEl.innerHTML = "<table></table>";
            document.body.appendChild(tooltipEl);
            }
            // Hide if no tooltip
            if (tooltip.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
            }
            // Set caret Position
            tooltipEl.classList.remove("above", "below", "no-transform");
            if (tooltip.yAlign) {
            tooltipEl.classList.add(tooltip.yAlign);
            } else {
            tooltipEl.classList.add("no-transform");
            }
            function getBody(bodyItem) {
            return bodyItem.lines;
            }
            // Set Text
            if (tooltip.body) {
            var titleLines = tooltip.title || [];
            var bodyLines = tooltip.body.map(getBody);
            var innerHtml = "<thead>";
            titleLines.forEach(function (title) {
                innerHtml += "<tr><th>" + title + "</th></tr>";
            });
            innerHtml += "</thead><tbody>";
            bodyLines.forEach(function (body, i) {
                var colors = tooltip.labelColors[i];
                var style = "background:" + colors.backgroundColor;
                style += "; border-color:" + colors.borderColor;
                style += "; border-width: 2px";
                var span =
                '<span class="chartjs-tooltip-key" style="' +
                style +
                '"></span>';
                innerHtml += "<tr><td>" + span + body + "</td></tr>";
            });
            innerHtml += "</tbody>";
            var tableRoot = tooltipEl.querySelector("table");
            tableRoot.innerHTML = innerHtml;
            }
            var position = this._chart.canvas.getBoundingClientRect();
            // Display, position, and set styles for font
            tooltipEl.style.opacity = 1;
            tooltipEl.style.left = position.left + tooltip.caretX + "px";
            tooltipEl.style.top = position.top + tooltip.caretY + "px";
            tooltipEl.style.fontFamily = tooltip._fontFamily;
            tooltipEl.style.fontSize = "30px";
            tooltipEl.style.fontStyle = tooltip._fontStyle;
            tooltipEl.style.padding =
            tooltip.yPadding + "px " + tooltip.xPadding + "px";
        },
        },
    },
    };
    this.loaded = true;

    //this.radargraph.renderChart(this.newData, this.options);
  },
  data: () => ({
    profileResponse: [],

    idx : -1,

    nextStepP1: "",
    nextStepP2: "",
    nextStepP3: "",
    nextStepP4: "",
    
    cMaturityLevel: 0,
    cMaturityIndicator: "",
    dMaturityLevel: 0,
    dMaturityIndicator: "",

    part1curr: 0,
    part1future: 0,
    part2curr: 0,
    part2future: 0,
    part3curr: 0,
    part3future: 0,
    part4curr: 0,
    part4future: 0,

    currentStateAverage: 0,
    desiredStateAverage: 0,

    matLevels: [],

    changeIndex: 0,
    changeCapability: "",
    changeCapabilityDescription: "",

    currentMatLevelID: 0,
    currentMatLevelIndicator: "",
    currentMatLevelBehavior: "",

    desiredMatLevelID: 0,
    desiredMatLevelIndicator: "",
    desiredMatLevelBehavior: "",

    recommendedMatLevelIndicator: "",
    recommendedMatLevelBehavior: "",

    loaded: false,

    newData: [],
    chartdata: {
      labels: [
        "Organisation, Strategy and Implementation",
        "Leadership, Engagement of People, Employee Competencies, Organisational change and Training",
        "IT and IT Infrastructure, Data, Data Centre, Communication Security and the Level of Digitalisation",
        "Supply Chain, Vertical and Horizontal Integration",
      ],
      datasets: [
        {
          label: "Where you are",
          backgroundColor: "rgba(255, 99, 132, 0.2)",
          borderColor: "rgb(255, 0, 132)",
          pointBackgroundColor: "rgb(255, 99, 0)",
          data: [0, 0, 0, 0],
        },
        {
          label: "Where you want to be",
          backgroundColor: "rgba(54, 162, 235, 0.2)",
          borderColor: "rgb(54, 0, 235)",
          pointBackgroundColor: "rgb(54, 162, 0)",
          data: [0, 0, 0, 0],
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "",
      },
      scale: {
        ticks: {
          beginAtZero: true,
          max: 5,
          min: 0,
          stepSize: 1,
        },
      },
      tooltips: {
        enabled: false,
        callbacks: {
          label: function (tooltipItem, data) {
            var datasetLabel =
              data.datasets[tooltipItem.datasetIndex].label || "";
            //This will be the tooltip.body
            return (
              datasetLabel +
              ": " +
              tooltipItem.yLabel +
              ": " //+
              //data.datasets[tooltipItem.datasetIndex].notes[tooltipItem.index]
            );
          },
        },
        custom: function (tooltip) {
          // Tooltip Element
          var tooltipEl = document.getElementById("chartjs-tooltip");
          if (!tooltipEl) {
            tooltipEl = document.createElement("div");
            tooltipEl.id = "chartjs-tooltip";
            tooltipEl.innerHTML = "<table></table>";
            document.body.appendChild(tooltipEl);
          }
          // Hide if no tooltip
          if (tooltip.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
          }
          // Set caret Position
          tooltipEl.classList.remove("above", "below", "no-transform");
          if (tooltip.yAlign) {
            tooltipEl.classList.add(tooltip.yAlign);
          } else {
            tooltipEl.classList.add("no-transform");
          }
          function getBody(bodyItem) {
            return bodyItem.lines;
          }
          // Set Text
          if (tooltip.body) {
            var titleLines = tooltip.title || [];
            var bodyLines = tooltip.body.map(getBody);
            var innerHtml = "<thead>";
            titleLines.forEach(function (title) {
              innerHtml += "<tr><th>" + title + "</th></tr>";
            });
            innerHtml += "</thead><tbody>";
            bodyLines.forEach(function (body, i) {
              var colors = tooltip.labelColors[i];
              var style = "background:" + colors.backgroundColor;
              style += "; border-color:" + colors.borderColor;
              style += "; border-width: 2px";
              var span =
                '<span class="chartjs-tooltip-key" style="' +
                style +
                '"></span>';
              innerHtml += "<tr><td>" + span + body + "</td></tr>";
            });
            innerHtml += "</tbody>";
            var tableRoot = tooltipEl.querySelector("table");
            tableRoot.innerHTML = innerHtml;
          }
          var position = this._chart.canvas.getBoundingClientRect();
          // Display, position, and set styles for font
          tooltipEl.style.opacity = 1;
          tooltipEl.style.left = position.left + tooltip.caretX + "px";
          tooltipEl.style.top = position.top + tooltip.caretY + "px";
          tooltipEl.style.fontFamily = tooltip._fontFamily;
          tooltipEl.style.fontSize = "30px";
          tooltipEl.style.fontStyle = tooltip._fontStyle;
          tooltipEl.style.padding =
            tooltip.yPadding + "px " + tooltip.xPadding + "px";
        },
      },
    },
  }),
};
</script>

<style scoped lang="scss">
@import "../assets/css/mdb.css";

.btn-primary {
  background-color: #33013d !important;
  border: 2px solid #cacaca !important;
}

.btn-primary:hover {
  background-color: rgb(0, 155, 219) !important;
}

.circle {
  background-color: rgb(0, 155, 219) !important;
}

canvas {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.primary-color,
ul.stepper li.active a .circle,
ul.stepper li.completed .circle {
    background-color: #50006a
}

.danger-color,
ul.stepper li.warning .circle {
    background-color: #50006a
}

ul.stepper {
    
    margin: 1em -1.5rem;
    overflow-x: hidden;
    overflow-y: auto;
    counter-reset: section
}

ul.stepper li {
    padding: 0.9rem;
    text-align: center
}

ul.stepper li .circle {
    display: inline-block;
    width: 1.75rem;
    height: 1.75rem;
    margin-right: .5rem;
    line-height: 1.7rem;
    color: #fff;
    text-align: center;
    background: rgba(0, 0, 0, 0.38);
    border-radius: 50%
}

ul.stepper li .label {
    display: inline-block;
    color: rgba(0, 0, 0, 0.38)
}

ul.stepper li.active .label,
ul.stepper li.completed .label {
    font-weight: 600;
    color: rgba(0, 0, 0, 0.87)
}

.step-content{
  text-align: left;
}

#chartjs-tooltip {
  opacity: 1;
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  border-radius: 3px;
  -webkit-transition: all 0.1s ease;
  transition: all 0.1s ease;
  pointer-events: none;
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
}

#chartjs-radar {
  width: 40%;
  height: 40%;
}

.chartjs-tooltip-key {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 10px;
}

.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.card{
    word-wrap : normal !important;
}

/*spinner styles*/
.loader {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Add animation to "page content" */
.animate-bottom {
  position: relative;
  -webkit-animation-name: animatebottom;
  -webkit-animation-duration: 1s;
  animation-name: animatebottom;
  animation-duration: 1s;
}

@-webkit-keyframes animatebottom {
  from {
    bottom: -100px;
    opacity: 0;
  }
  to {
    bottom: 0px;
    opacity: 1;
  }
}

@keyframes animatebottom {
  from {
    bottom: -100px;
    opacity: 0;
  }
  to {
    bottom: 0;
    opacity: 1;
  }
}
</style>
